import { useErrorBoundary } from "preact/hooks";
import { useMachine } from "@xstate/react";
import { windroseDataMachine } from "./machines";
import { MakeWindrose } from "./components/WindRose";
import {
  DefineData,
  LoadFromFile,
  LoadPreviousData,
  ShowExample,
  SelectInitialDataButtons,
} from "./components/SelectInitialData/";
import { DefineMetadata } from "./components/SelectInitialData/DefineData/";

const AppPatternMatcher = ({ current, send }) => {
  switch (true) {
    case current.matches("selectInitData.defineData"):
      return (
        <DefineData defineOwnDataMachine={current.children.defineOwnData} />
      );
    case current.matches("selectInitData.useExample"):
      return (
        <ShowExample onConfirmExample={() => send("CONFIRM_EXAMPLE_DATA")} />
      );
    case current.matches("selectInitData.loadPrevious"):
      return (
        <LoadPreviousData
          onSetPrevData={(data) => send({ type: "SET_PREV_DATA", ...data })}
          onConfirmPrevData={() => send("CONFIRM_PREV_DATA")}
        />
      );
    case current.matches("selectInitData.uploadFile"):
      return (
        <LoadFromFile
          onSetFileData={(data) => send({ type: "SET_FILE_DATA", ...data })}
          onConfirmFile={() => send("CONFIRM_FILE")}
        />
      );
    case current.matches("enterMetadata"):
      return (
        <DefineMetadata
          onGoBack={() => send("GO_BACK")}
          onConfirmMetadata={() => send("CONFIRM_METADATA")}
          onSetYUnits={(e) =>
            send({ type: "SET_Y_UNITS", yUnits: e.target.value })
          }
          onSetBinsTitle={(e) =>
            send({ type: "SET_BINS_TITLE", binsTitle: e.target.value })
          }
          onSetBinUnits={(e) =>
            send({ type: "SET_UNITS", binUnits: e.target.value })
          }
          binsTitle={current.context.binsTitle}
          yUnits={current.context.yUnits}
          binUnits={current.context.binUnits}
        />
      );
    case current.matches("editWindrose"):
      return (
        <MakeWindrose
          showDonateModal={current.matches("editWindrose.donationPopup")}
          onDownloadSvg={() => send("DOWNLOAD_SVG")}
          onDownloadPng={() => send("DOWNLOAD_PNG")}
          bins={current.context.bins}
          initialTableData={current.context.tableData}
          binsTitle={current.context.binsTitle}
          yUnits={current.context.yUnits}
          binUnits={current.context.binUnits}
          tableColumns={current.context.tableColumns}
          onClickedNo={() => send("NAH")}
        />
      );
    default:
      return null;
  }
};

// inspect({ iframe: false });

function Home() {
  const [current, send] = useMachine(windroseDataMachine); //{ devTools: true }
  const [error, resetError] = useErrorBoundary(); // TODO: Sentry here: (error => callMyApi(error.message))

  // console.log(current.value)

  if (error) {
    return (
      <div class="px-8 py-4 text-white bg-red-400 mt-2 rounded-lg shadow">
        <h1 class="h1 text-white">An error occurred :(</h1>
        <p>{error.toString()}</p>
        <button class="btn" onClick={resetError}>
          Try again
        </button>
      </div>
    );
  }

  return (
    <>
      {current.matches("selectInitData") ? (
        <SelectInitialDataButtons
          matches={current.matches}
          onDefineData={() => send("DEFINE_DATA")}
          onShowExample={() => send("SHOW_EXAMPLE")}
          onLoadPrevData={() => send("LOAD_PREV_DATA")}
          onShowUpload={() => send("UPLOAD_FILE")}
        />
      ) : null}
      <AppPatternMatcher current={current} send={send} />
    </>
  );
}

export default Home;
